/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { useConversationFeatures } from 'src/luis/modules/features/hooks/useConversationFeatures';
import { Feature } from 'src/luis/modules/features/types/Feature';
import { Intent } from 'src/luis/modules/intents/Intent';
import { CompositeEntity } from 'src/luis/projects/entities/types/CompositeEntity';
import { Entity } from 'src/luis/projects/entities/types/Entity';
import { SimpleEntity } from 'src/luis/projects/entities/types/SimpleEntity';
import { filterAvailableFeatures } from 'src/luis/projects/entities/utils/entityHelpers';
import { ModelType } from 'src/luis/types/ModelType';

/**
 * Returns the features that can be used as features for the given model
 * filtered of the already exist features.
 *
 * @param model The model to get the available feature for.
 */
export const useAvailableFeatures = (model: Intent | CompositeEntity | SimpleEntity): Feature[] => {
    const { features } = useConversationFeatures();

    if (model && model.typeId === ModelType.Intent) {
        return features.filter(feature => model && feature.id !== model.id && model.features.every(f => f.id !== feature.id));
    }
    return filterAvailableFeatures(<Entity>model, features);
};
